import { Extension, KeyboardShortcutCommand } from '@tiptap/core';

interface KeyHandlerOptions {
  shortcuts: {
    [key: string]: KeyboardShortcutCommand;
  };
}

const KeyHandler = Extension.create<KeyHandlerOptions>({
  name: 'keyHandler',
  addOptions() {
    return {
      shortcuts: {},
    };
  },

  addKeyboardShortcuts() {
    return this.options.shortcuts;
  },
});

export default KeyHandler;
